/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Sep 20 2023
 **/

import { Column, Typography } from "@/frameworks/designStuff/components";
import { Maybe } from "@/frameworks/libraries/components";

import * as S from "./emotion";
import FileImage from "./FileImage";
import { FileDescriptor, FileName, FileUploader } from "./components";

interface FileCard {
	file: Required<FileBox.Folders.GetFolderFileListResponse>["content"][number];
	status?: "waiting" | "in-use" | "used";
	searchText: string;
}

export default function FileCard({ file, status = "waiting", searchText }: FileCard) {
	return (
		<S.CardWrapper tabIndex={0} status={status}>
			<FileImage file={file} />
			<S.FileInfoWrapper gap={12}>
				<Column css={{ width: "calc(100% - 32px - 12px)" }}>
					<FileName fileName={file.name ?? ""} searchText={searchText} />
					<Maybe test={file.fileBoxType === "LINK"}>
						<Typography
							typoSize="Body5"
							typoColor="neutral_70_100"
							align="left"
							maxLine={1}
							ellipsis
							css={{ width: "100%" }}
						>
							{file.link}
						</Typography>
					</Maybe>
					<FileUploader file={file} />
					<FileDescriptor file={file} />
				</Column>
			</S.FileInfoWrapper>
		</S.CardWrapper>
	);
}
